"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SUBSCRIBE_SECONDARY_BUTTON = exports.SUBSCRIBE_PRIMARY_BUTTON = void 0;
const SUBSCRIBE_PRIMARY_BUTTON = exports.SUBSCRIBE_PRIMARY_BUTTON = 'subscribe-primary-button';
const SUBSCRIBE_SECONDARY_BUTTON = exports.SUBSCRIBE_SECONDARY_BUTTON = 'subscribe-secondary-button';
//# sourceMappingURL=constants.js.map